import { Component, OnInit, Input, OnChanges } from '@angular/core';

import { Simulation } from '@classes/simulation/simulation';
import { KpiByYear } from '@classes/simulation/kpi-by-year';
import { Kpi } from '@classes/simulation/kpi';
import { SimulationService } from '@services/simulation.service';
import { Partition } from '@classes/simulation/partition';
import { SimulationFlagType } from '@enums/simulation-flag-type.enum';

@Component({
    selector: 'app-live-simulator',
    templateUrl: './live-simulator.component.html',
    styleUrls: ['./live-simulator.component.scss']
})
export class LiveSimulatorComponent implements OnInit, OnChanges {
    @Input() simulation: Simulation;
    @Input() selectedYear: KpiByYear;

    isFormVisible = false;
    filteredKpis: Kpi[];

    constructor(
        private simuSrv: SimulationService
    ) { }

    ngOnInit() {
        this.getSelectedData();
    }

    ngOnChanges() {
        this.getSelectedData();
    }

    changePartValue(data: {operator: string, selectedPart: Partition}): void {
        const step = data.selectedPart.cursorParameters.step;

        // value edited by reference
        data.selectedPart.simulationValues.indice = this.calculateIndice(data.selectedPart.simulationValues.indice, data.operator, step);
        data.selectedPart.simulationValues.years.map(y => {
            y.indice = this.calculateIndice(y.indice, data.operator, step);
        });
        data.selectedPart.simulationValues.flag = SimulationFlagType.modified;

        this.applyToChildren(data.selectedPart.partitionDetails.code, step, data.operator);
        this.simuSrv.calculateLocal(data.selectedPart.partitionDetails.code);
    }

    onApplyCompletionRate(): void {
        this.simuSrv.calculate(this.simulation);
    }

    onResetSimu(): void {
        this.simuSrv.resetSimulation();
    }

    onToggleForm(): void {
        this.isFormVisible = !this.isFormVisible;
    }

    getMidLength(less = 0): number {
        return Math.floor(this.simulation.kpisByYear.length / 2) - less;
    }

    private getSelectedData(): void {
        this.filteredKpis = [... this.selectedYear.kpis.filter(kpi => kpi.isChartVisible)];
    }

    private applyToChildren(parentCode: string, step: number, operator: string): void {
        const parentCodes = [parentCode];

        this.simulation.partitions.map((partition, i) => {
            if(parentCodes.indexOf(partition.parentCode) !== -1) {
                if(this.simulation.partitions[i + 1] && this.simulation.partitions[i + 1].parentCode === partition.partitionDetails.code) {
                    parentCodes.push(partition.partitionDetails.code);
                } else {
                    partition.simulationValues.indice = this.calculateIndice(partition.simulationValues.indice, operator, step);
                    partition.simulationValues.years.map(y => {
                        y.indice = this.calculateIndice(y.indice, operator, step);
                    });
                    partition.simulationValues.flag = SimulationFlagType.inherited;
                }
            }
        });
    }

    private calculateIndice(indice: number = 0, operator: string = '+', step: number = 0): number {
        switch(operator) {
            case '+':
                return indice += step;
            case '-':
            default:
                return indice -= step;
        }
    }
}
